export { default } from './Typography';
export type { Props, Variant } from './Typography';
